import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Urls } from '@core/config';
import { Observable } from 'rxjs';
import { RegisterExpired } from '../models/register-expired';

@Injectable()
export class RegisterExpiredService {
	private get _url(): string {
		return Urls.BASE_URL.toString() + '/sec/public/security/users/reactivate-key';
	}

	constructor(private http: HttpClient) {}

	public resendActivationLink(data: RegisterExpired): Observable<unknown> {
		return this.http.post(this._url, data);
	}
}
